import CarouselForm from "../Components/CarouselForm";
import CourseDetails from "../Components/Courses/CourseDetails";
import SpecificCourse from "../Components/Courses/SpecificCourse";
import TableWithProgress from "../Components/Table/ProgressTable";
import NewWidget from "../Components/TestWidget";
import AssessmentResult from "../pages/AssessmentResult";
import AzureLoginRedirect from "../pages/AzureLoginRedirect";
import BeforeApprovalDashboard from "../pages/BeforeApprovalDashboard";
import Calender from "../pages/Calender";
import Communication from "../pages/Communication";
import Courses from "../pages/Courses";
import ForgotPassword from "../pages/ForgotPassword";
import GetToKnow from "../pages/GetToKnow";
import InvitesUserInCoursera from "../pages/InvitesUserInCoursera";
import JobNotification from "../pages/JobNotification";
import OtpForgotPassword from "../pages/OtpForgotPassword";
import Preferences from "../pages/Preferences";
import Profile from "../pages/Profiles/Index";
import Portfolio from "../pages/Profiles/Portfolio";
import CreateNewUser from "../pages/CreateNewUser";
import Register from "../pages/Register";
import ResetPassword from "../pages/ResetPassword";
import SignIn from "../pages/SignIn";
import Survey from "../pages/Survey";
import SurveyForm from "../pages/SurveyForm";
import TalentCurrentStatus from "../pages/TalentCurrentStatus";
import ThingsToDo from "../pages/ThingsToDo";
import TierInformation from "../pages/TierInformation";
import WelcomePage from "../pages/WelcomePage";
import ProjectDetails from "../Components/ProjectTab/ProjectDetails";
import ProjectDataDetails from "../Components/ProjectTab/ProjectDataDetails";
import Test from "../Components/Test";
import SubmittedIdeaDetail from "../Components/ProjectTab/SubmittedIdeaDetail";
// import InterestedDetails from "../pages/InterestedDetails";
// import LoadingCom from "../Components/LoadingCom";
import NotApproved from "../Components/NotApproved.jsx";

export const ALL_PROTECTED_ROUTES = [
  { path: "/tier-information", component: TierInformation },
  { path: "/job-notification", component: JobNotification },
  { path: "/current-status", component: TalentCurrentStatus },
  { path: "/", component: NewWidget },
  { path: "/preferences", component: Preferences },
  { path: "/form", component: CarouselForm },
  // { path: "/widget", component: NewWidget },
  // { path: "/testwidget", component: TestWidget },
  // { path: "/profile", component: Profile },
  { path: "/portfolio", component: Portfolio },
  // { path: "/dashboard", component: Dashboard },
  { path: "/talent-assessment", component: Courses },
  // { path: "/sadsadsad", component: CourseDetails },
  { path: "/courses/:id", component: SpecificCourse },
  { path: "/courses/:courseId", component: CourseDetails },
  { path: "/projects/:projectId", component: ProjectDetails },
  { path: "/projects-details/:projectId", component: ProjectDataDetails },
  { path: "/submitted-ideas/:Id", component: SubmittedIdeaDetail },
  { path: "/communication", component: Communication },
  { path: "/things-to-do", component: ThingsToDo },
  { path: "/calender", component: Calender },
  { path: "/add-new-user", component: CreateNewUser },
  { path: "/table", component: TableWithProgress },
  { path: "/assessment-result", component: AssessmentResult },
  { path: "/invite-user-coursera", component: InvitesUserInCoursera },
  { path: "/welcome", component: WelcomePage },
];

export const ALL_PUBLIC_ROUTES = [
  { path: "/welcome", component: WelcomePage },
  { path: "/signin", component: SignIn },
  { path: "/signup", component: Register },
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/password-reset-otp", component: OtpForgotPassword },
  { path: "/reset-password", component: ResetPassword },
  {
    path: "/verify-email",
    component: OtpForgotPassword,
    props: { confirmEmail: true, href: "/signin" },
  },
  { path: "/get-to-know", component: GetToKnow },
  { path: "/before-approval", component: BeforeApprovalDashboard },
  { path: "/redirect-login", component: AzureLoginRedirect },
  { path: "/survey-form", component: SurveyForm },
  { path: "/survey", component: Survey },
  { path: "/test", component: Test },
];
export const TALENT_NOT_APPROVED = [
  { path: "/", component: Portfolio },
  { path: "/portfolio", component: Portfolio },
  { path: "/welcome", component: WelcomePage },
];
export const ADMIN_NOT_APPROVED = [{ path: "/", component: NotApproved }];
